export default __webpack_public_path__ + "static/media/BAKA_ikona_web_odabrano-04.968e95ab.svg";